"use client"
import {
  useInputGroup
} from "./chunk-N7GDIMME.mjs";

// src/input-addon.tsx
import { forwardRef, ui } from "@yamada-ui/core";
import { cx } from "@yamada-ui/utils";
import { jsx } from "react/jsx-runtime";
var InputAddon = forwardRef(
  ({ className, placement = "left", ...rest }, ref) => {
    const { styles } = useInputGroup();
    const placementStyles = {
      left: {
        me: "-1px",
        roundedRight: "0px !important"
      },
      right: {
        ms: "-1px",
        roundedLeft: "0px !important"
      }
    };
    const css = {
      alignItems: "center",
      display: "flex",
      flex: "0 0 auto",
      w: "auto",
      whiteSpace: "nowrap",
      ...styles.addon,
      ...placementStyles[placement]
    };
    return /* @__PURE__ */ jsx(
      ui.div,
      {
        ref,
        className: cx("ui-input__addon", className),
        __css: css,
        ...rest
      }
    );
  }
);
InputAddon.displayName = "InputAddon";
InputAddon.__ui__ = "InputAddon";
var InputLeftAddon = forwardRef(
  ({ className, ...rest }, ref) => {
    return /* @__PURE__ */ jsx(
      InputAddon,
      {
        ref,
        className: cx("ui-input__addon--left", className),
        placement: "left",
        ...rest
      }
    );
  }
);
InputLeftAddon.displayName = "InputLeftAddon";
InputLeftAddon.__ui__ = "InputLeftAddon";
var InputRightAddon = forwardRef(
  ({ className, ...rest }, ref) => {
    return /* @__PURE__ */ jsx(
      InputAddon,
      {
        ref,
        className: cx("ui-input__addon--right", className),
        placement: "right",
        ...rest
      }
    );
  }
);
InputRightAddon.displayName = "InputRightAddon";
InputRightAddon.__ui__ = "InputRightAddon";

export {
  InputLeftAddon,
  InputRightAddon
};
//# sourceMappingURL=chunk-HSHTS6CU.mjs.map